import { type Route } from '@cms/common/types/Route';

import { NamespacesByRoute } from '../routing/types/NamespacesByRoute';
import { Ns } from './types';

export const I18N_NAMESPACES = Object.values(Ns);

export const defaultNamespaces = [
    Ns.Actions,
    Ns.Betting,
    Ns.Common,
    Ns.Components,
    Ns.Datetime,
    Ns.Error,
    Ns.Footer,
    Ns.Meta,
    Ns.Newslist,
    Ns.Secure,
    Ns.Sidebar,
    Ns.Stats,
    Ns.Url,
];

export const routeNamespaces: Record<Route, string[]> = NamespacesByRoute;

export const namespaces = { defaultNamespaces, routeNamespaces };
